module.exports = __webpack_public_path__ + "img/correction.bb4997ea.png";